require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-the-international-finance-corp-ifc-the-world-bank.json") })
        }
      }, "path---en-us-update-the-international-finance-corp-ifc-the-world-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-the-international-finance-corp-ifc-the-world-bank!./.cache/json/en-us-update-the-international-finance-corp-ifc-the-world-bank.json
// module id = 804
// module chunks = 231608221292675